import {getRefTagAndOrigin} from '@jobseeker/common-core/utils';
import {handleTracking} from '@jobseeker/common-core/utils';
import loadAds from '@jobseeker/common-core/helpers/loadAds';

// Defines pages which are using Promotion banner of type 1 (having static banner data)
const STATIC_BANNER_PAGES: Record<string, string> = {
  jobdetail: 'Job Detail Page',
};

// Defines pages which are using Promotion banner of type 2 (getting banner data from api)
const DYNAMIC_BANNER_PAGES: Record<string, string> = {
  search: 'Search Page',
  jobfeed: 'Jobfeed Page',
  tag: 'Tag Page',
};
interface Banner {
  heading: string;
  subHeading: string;
  redirectLink: string;
  imageUrl: string;
  button: string;
}

interface DownloadBanner {
  redirectLink: string;
  label: string;
}

interface SlotIds {
  TOP: string;
  MIDDLE: string;
  BOTTOM: string;
}

const getRandomInt = (max: number) => {
  // if max is 4 then it will return a random number from 0 to 3 (both inclusive)
  return Math.floor(Math.random() * max);
};

//get app banner data from ad slots
const getAppBannerData = async (slotId: string, randomNo: number) => {
  const resData = await loadAds(slotId, {}, false, true);
  const adList = resData?.data?.adList;
  if (adList && adList.length > 0) {
    const requestedAd = adList[randomNo];
    const metaData = requestedAd?.metadata;
    return metaData[0];
  }
  return {};
};

const getBannerData = async (
  page: string,
  slotId: string,
  eventInfo: {[key: string]: string},
  randomNo = 1,
  doTracking = false
) => {
  if (doTracking == true) {
    handleTracking(eventInfo['view'], {
      event_category: eventInfo['eventCategory'],
      Origin: page,
      UserId: sessionStorage.getItem('userId') || 'NA',
      Device: sessionStorage.getItem('device') || 'desktop',
      Device_Type: sessionStorage.getItem('deviceType') || 'web',
      Status: sessionStorage.getItem('status') || 'LoggedOut',
    });
  }
  const bannerData = await getAppBannerData(slotId, getRandomInt(randomNo));
  return bannerData;
};

export const getBannerInfo = async (
  page: string,
  slots: SlotIds
): Promise<Banner | null> => {
  let bannerInfo: Banner | null = null;
  if (page in STATIC_BANNER_PAGES) {
    let startTime = new Date().getDate();
    startTime %= 3;
    const bannerData = [
      {
        heading: 'Stay updated, always!',
        subHeading:
          'Get real-time notifications and job recommendations on our app!',
        button: 'GET APP',
      },
      {
        heading: 'Download the hirist mobile app!',
        subHeading:
          'Get notified about jobs relevant to you and stay ahead in your job search!',
        button: 'INSTALL',
      },
      {
        heading: 'Get real-time updates!',
        subHeading:
          'Download the hirist mobile app and stay updated about your application status!',
        button: 'GET APP',
      },
    ];
    bannerInfo = {
      ...bannerData[startTime],
      redirectLink: 'https://hirist.onelink.me/Z1Mi/7c30xras',
      imageUrl: '',
    };
  } else if (page in DYNAMIC_BANNER_PAGES) {
    const bannerData = await getBannerData(page, slots['TOP'], 2);
    if (Object.keys(bannerData)?.length > 0) {
      bannerInfo = {
        heading: bannerData['Text'],
        subHeading: bannerData['Sub Text'],
        redirectLink: bannerData['Redirection Link'],
        imageUrl: bannerData['Image Url'],
        button: bannerData['CTA Text'],
      };
    }
  }
  return bannerInfo;
};

export const getDownloadAppBannerData = async (
  page: string,
  slots: SlotIds,
  eventInfo: {[key: string]: string}
): Promise<DownloadBanner | null> => {
  let downloadBannerInfo: DownloadBanner | null = null;
  const downloadBannerData = await getBannerData(
    page,
    slots['BOTTOM'],
    eventInfo,
    1,
    true
  );
  if (Object.keys(downloadBannerData)?.length > 0) {
    downloadBannerInfo = {
      redirectLink: downloadBannerData['Redirection Link'],
      label: downloadBannerData['CTA Text'],
    };
  }
  return downloadBannerInfo;
};
